import { inject, Injectable } from '@angular/core';
import { AppRoutes } from '@core/routes/route.paths';
import { UserService } from '@core/services/user/user.service';
import { SubMenu } from '@shared/model/menu-item.type';

@Injectable({ providedIn: 'root' })
export class ClientMenuService {
  private readonly userService = inject(UserService);

  getMenu(): SubMenu {
    return {
      root: { label: 'clients', routerLink: AppRoutes.Clients.root },
      items: [
        { label: 'sub-menu-configuration.client-selection', routerLink: AppRoutes.Clients.root },
        { label: 'sub-menu-configuration.client-mngt', routerLink: AppRoutes.Clients.ClientMngt },
        {
          label: 'sub-menu-configuration.client-import',
          routerLink: AppRoutes.Clients.Import,
          show: () => this.userService.isSupport(),
        },
      ],
    };
  }
}
